import React from "react"
import { Paragraph } from "../../ui"

export const OkMessage = () => (
  <>
    <Paragraph>
      Parabéns você cadastrou os dados da instituição com sucesso!
      <br />
      <strong>Sua instituição já pode receber doações!</strong>
    </Paragraph>
    <Paragraph>
      Agora é necessário que sejam enviados o(s) documento(s) listados abaixo,
      para que o dinheiro arrecado seja transferido para a conta cadastrada.
      Enquanto você não enviar os documentos ele não poderá ser transferido para
      a conta cadastrada.
    </Paragraph>
  </>
)
